import { Component, ComponentFactoryResolver, Injector, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@app-services/user/user.service';
import { TestComingSoonDialogComponent } from '@app-shared/components/test-coming-soon-dialog/test-coming-soon-dialog.component';
import * as moment from 'moment';
import { Location } from '@angular/common'
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { ExamService } from '@app-services/test/exam.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { TenantConstant } from '@app-constants/tenant.constant';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { SubscribemodalComponent } from '@app-shared/components/subscribemodal/subscribemodal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountConfirmDialogComponent } from '@app-shared/components/account-confirm-dialog/account-confirm-dialog.component';
import { allowedExamNamesCT, allSubjectsInOrder, apisDataCacheKeys, irregularExamtypes, neetNewVerTypes, negativeScorePerQuestion, scorePerQuestion, secACount, secBCorrect, secBCount, subjectLogos, timeBoundTypes } from '@app-constants/app.constants';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { filterCMSData, getChapterOrTopicObject, getCourseName, getExamName, getMomentUTCtime, getTimeDetails, isUserAdmin, timeConvert } from '@app-helpers/functions';
// import { ViewSolutionComponent } from '../dialog/view-solution/view-solution.component';
import { TaskTimer } from 'tasktimer';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { KeyValue } from '@angular/common';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { EnjoyingAppDialogComponent } from '@app-modules/feature/my-referral/enjoying-app-dialog/enjoying-app-dialog.component';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { ScoreGiftDialogComponent } from '../../score-gift-dialog/score-gift-dialog.component';
import { environment } from '@app-environments/environment';
import { finalize } from 'rxjs/operators';
import { FreeScoreGiftDialogComponent } from '../../free-score-gift-dialog/free-score-gift-dialog.component';
import { ScoreCertificateComponent as scorecertificatecomponent} from '@app-shared/components/score-certificate/score-certificate.component';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { MyactivityService } from 'src/app/core/services/myactivity.service';
import { FirebaseService } from '@app-services/firebase/firebase.service';
declare var $:any;

@Component({
  selector: 'app-test-results',
  templateUrl: './test-results.component.html',
  styleUrls: ['./test-results.component.css']
})
export class TestResultsComponent implements OnInit,OnDestroy{
  viewSolutionAvailableTimebound: boolean = false;
  viewSolutionAvailabilityInterval: any = null;
  scheduleIdFound: boolean = false;
  scheduleId: any;
  environmentProd=environment;
  rankInterval: any = null;
  numberOfTimeApiHitsForRank = 0;
  testResponses: any = [];
  user:any;
  // examdata: any;
  token: any;
  alltestlist = [];
  allChapters: any = [];
  data:any=[10,20];
  tabs:any;
  chartsDatas: {
    correctAnswer: 0,
    incorrectAnswer: 0,
    unAttemptedQuestions: 0
  }
  showCharts: boolean = false;
  existSections = {

  }
  showSectionWiseReport: boolean = false;
  sectionData: any;
  selectesSectionInd: number;
  selectedSectionToShow: string;
  bestSubjectChapters:any = {};
  userData:any;
  feedBack:any
  quesCount;
  userPositiveLoginDetailsId:any;
  trackingData: any;
  dialogRefGifts: any;
  QuestionsData :any = {}
  showEqualiser: boolean =false;
  testResultUtilityObject :any= {
    showScoreRace :false
  }
  examRanges: any;
  subscriptionsArray :any  =[];
  autoRedirectionfix=environment?.autoRedirectionfix;
  enableBestSubjectChanges=environment?.enableBestSubjectChanges;
  constructor(private examService: ExamService,
    private _eventHandlingService: EventHandlingService,
    private storage: LocalStorageService,
    private router: Router,
    private testListService: TestlistService,
    private spinner: NgxSpinnerService,
    private userService: UserService,
    public dialog: MatDialog,
    private location:Location,
    public modalservice:NgbModal,
    private route: ActivatedRoute,
    private _inviteNdEarn:InviteEarnService,
    public resolver :ComponentFactoryResolver,
    public injector :Injector,
    private subscriptionService: SubscriptionService,
    private AchievementsService : MyactivityService,
    private navigationService:NavigationService,
    public viewContainerRef: ViewContainerRef,
    private firebaseService: FirebaseService) { }
    private isPaidUser: boolean = false;
    paperReady :boolean = false
  averageScore: any = 90;
  cutOffScore: any = 70;
  examinfo: any;
  rules: any;
  results: any;
  testReport: any = {
    testname: '',
    totaltimespentinhrs:'',
    accuracy: 0,
    bestSubject: '',
    scopeOfImprovement: '',
    bestChapter: '',
    scopeOfImprovementChapter: '',
    correctAnswer: 0,
    incorrectAnswer: 0,
    attemptedQuestions: 0,
    outOfScore: 0,
    totalScore: 0,
    unAttemptedQuestions: 0,
    totalQuestions: 0,
    totalVisitedQuestions: 0,
    totalVisitedTime: 0,
    averageTimePerQuestion: 0,
    testSubjects: [],
    rank: 0,
    percentile:0,
    overallChartData: {
        labels: ['Correct', 'Incorrect', 'Unattempted'],
        data: []
    }
  };
 
  scheduleTestInfos: any = [];
  timeConvert = timeConvert;
  getTimeDetails = getTimeDetails;
  getExamName =getExamName;
  sendDetailsToLSQ = sendDetailsToLSQ
  checkILTSRevampapplicable =checkILTSRevampapplicable
  checkJEEAdvancedMultiplePaper =checkJEEAdvancedMultiplePaper;
  getMomentUTCtime = getMomentUTCtime;
  tenant : any = TenantConstant.tenant;
  isTimeBoundTest: boolean = false;
  giftPopupInfo: any;
  showGiftPopup:boolean = false;
  testResultUtility:any = {
    paperSelectedOption:'',
    overallpaperResult:[],
    overallpaperSelected :false,
    targetExam:localStorage.getItem('targetExamName'),
    totalQestionDataResponse:{}
  }
  // @ViewChild('scorecomponent ',{read:ViewContainerRef}) public scorecomponent:ViewContainerRef;

  isnan(val){
    return isNaN(val);
  }

  ngOnInit(): void {
    this.examinfo = this.examService.getPresentExamInfo();
    let testType = Array.isArray(this.examinfo?.test_type) ? this.examinfo?.test_type?.[0]: (typeof this.examinfo?.test_type =='string'?this.examinfo?.test_type:'')
    this.examinfo.examtype= this.getExamName(testType)
    if(this.examinfo?.examtype == 'subjectivemocktest'){
        this.back()
      }else{
        // this.fetchAvgAndCutOffScore(this.examinfo, this.examinfo?.courseType);
      }
      this.isTimeBoundTest = timeBoundTypes.indexOf(this.examinfo.examtype) > -1;
      if(this.isTimeBoundTest){
        this.updateViewSolutionAvailabilityTimeboundTest()
        this.redirectToTimeBoundTest();
      }
    this.testListService.isUserSubscribed(this.examinfo.examtype,this.examinfo).then((resp:any)=>{
      if(!this.testListService.getUSerExamlist){
        let body ={
          "studentId":  localStorage.getItem('studentid'),
          "testType": this.examinfo?.test_type
        }
        this.testListService.getNotCompletedTest(body).subscribe((resp:any)=>{
          this.testListService.getUSerExamlist = resp;
          this.setPaperRuleID()
        })
      }else{
        this.setPaperRuleID()
      }
   
      if(resp && this.tenant != 'srichaitanya') {
        this.isPaidUser  = true;
      }
      setTimeout(()=>
      {
        this.checkPreConditionsForGifts();
      }
      , 5000);
    })
    this.userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    this.quesCount=JSON.parse(localStorage.getItem('answeredQues'));
    this.feedBack=JSON.parse(localStorage.getItem('ngx-webstorage|examreview'));
    this.route.queryParams.subscribe(params => {

      this.scheduleId = params['schedule']?params['schedule']:'';
      if(this.scheduleId) {
        this.scheduleIdFound = true;
      }
      // this.initFunc()
      // this. getReportUSingV2TestTeport()
    });
    if(this.checkILTSRevampapplicable(this.examinfo)){
      this.showEqualiser = true
    }
    this.AchievementsService.badgeInvokeSubject.next("Learn Component");
  }

  checkPreConditionsForGifts(){
    if(this.examinfo.examtype != 'SCHOLARSHIPTEST' || this.examinfo.examtype != 'SCOREAWAT' ){
      if(this.checkIfGiftCoupenAvailable() && (!this.isPaidUser)) this.scGiftCoupn();
    } else{
      if(this.checkIfGiftCoupenAvailable()) this.scGiftCoupn();
    }
  }

  checkPreConditionsForGiftsToDisplayGiftIcon(){
    if(this.examinfo.examtype != 'SCHOLARSHIPTEST'|| this.examinfo.examtype != 'SCOREAWAT'){
      if(this.checkIfGiftCoupenAvailable() && (!this.isPaidUser)) return true
      else return false;
    } else{
      if(this.checkIfGiftCoupenAvailable()) return true;
    }
  }

  //?tests callTrackApi Data sending
  sendData(){
    let examName;
    let experience;
    let difficultylevel;
    let payload;
    let subjects='';

    if(this.examinfo?.examtype=="TIMEBOUND"){
      examName='ILTS';
    }else if(this.examinfo?.examtype=='PREVIOUSYEAR'){
      examName='PYP';
    }else if(this.examinfo?.examtype=='SCOREMOCKTEST'){
      examName='SCORE Mock Test';
    }
    else{
      examName=this.examinfo?.examtype;
    }
    if(this.feedBack?.experience=='GOOD'){
      experience=3;
    }else if(this.feedBack?.experience=='FAIR'){
      experience=2;
    }else if(this.feedBack?.experience=='BAD'){
      experience=1;
    }

    if(this.feedBack?.difficultylevel[0]=='EASY'){
      difficultylevel=1;
    }else if(this.feedBack?.difficultylevel[0]=='MEDIUM'){
      difficultylevel=2;
    }else if(this.feedBack?.difficultylevel[0]=='HARD'){
      difficultylevel=3;
    }
    this.examinfo?.subjectsdata?.forEach(element => {
     subjects+=element.subjectname+',';
    });
    payload={
      data:{
      tests_exam_type:examName,
      tests_test_status:'Submitted',
      tests_test_name:this.examinfo.rulename,
      tests_score:this.testReport?.totalScore+'/'+this.testReport?.outOfScore,
      // class_name: this.examinfo.className,
      tests_subject: subjects,
      // schedulename:this.examinfo.schedulename,
      tests_percentile:this.testReport?.percentile,
      tests_test_feedback_1:experience,
      tests_test_feedback_2:difficultylevel,
    },
    landingPage : "LSQ_CUSTOM_EVENTS"
        };
    let  firebasePayload = {
      "ActivityDateTime": moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      "ActivityEvent": 261,
      "Fields":{},
      "FirstName": this.userData?.firstName,
      "LastName": this.userData?.lastName,
      "environment": environment?.branch,
      "phone": this.userData?.phone,
      "productId": 1,
      "type": "Activity"
    }
    isUserAdmin(this.userService).then((bool) => {
      if(!bool) {
        // this.userService.callTrackingAPI2(this.userData.userId, payload,'Act_Tests').subscribe((data)=>{
        //   this.spinner.hide();
        // },err=>{
        //   this.spinner.hide();
        // });

        this.firebaseService.getSqsValue().then((firebaseRSP) => {
          firebasePayload.Fields = {
            mx_Custom_10:examName,
            mx_Custom_9:'Submitted',
            mx_Custom_8:this.examinfo.rulename,
            mx_Custom_1:this.testReport?.totalScore+'/'+this.testReport?.outOfScore,
            // class_name: this.examinfo.className,
            mx_Custom_13: subjects,
            // schedulename:this.examinfo.schedulename,
            mx_Custom_2:this.testReport?.percentile,
            mx_Custom_11:experience,
            mx_Custom_12:difficultylevel,
          }
          if(examName !=='ILTS'){
            this.userService.sendSQSMsg(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,firebasePayload);
          }
          this.spinner.hide();
          localStorage.removeItem('answeredQues')
        }).catch((e) => {
          console.log(e);
          this.spinner.hide();
          localStorage.removeItem('answeredQues')
        });
      }
    },err=>{
      this.spinner.hide();
    })
  }

  sendFeedbackData(){
    let currentLogin=JSON.parse(localStorage.getItem('loginCount'));
    let ratingData;
    let prodctId=2;
    if(this.feedBack?.experience=='GOOD'){
      ratingData=5;
    }else{
      ratingData=0;
    }
    this._inviteNdEarn.sendFeedbackData(currentLogin,prodctId,ratingData,this.userData.userId).subscribe({next:(e)=>{
      this.userPositiveLoginDetailsId=e['userPositiveLoginDetailsId'];
      if(e['positiveLoginCount']==5||e['remindMeLaterCount']==1){
        this.enjoyAppInvite();
      }
        },error:(err)=>{;
    }})
  }

  enjoyAppInvite() {
    const config: MatDialogConfig = {
      panelClass: ['REF-enjoyapp-dialog', 'UNFAPP-mweb-btmstiky-modal'],
      width:'250',
      data: { },
    };
    const dialogRef = this.dialog.open(EnjoyingAppDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if(value?.data){
        this.router.navigateByUrl('/dashboard/referral/')
      }else{
        //? calling reminder api
        this._inviteNdEarn.remindMeLaterPopup(this.userPositiveLoginDetailsId);
      }
    });
  }

  getReportUSingV2TestTeport() {
    let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    var body = {
      "ruleid": this.testResultUtility.paperSelectedOption?this.testResultUtility.paperSelectedOption:( this.examinfo?.testrule_id || this.examinfo?._id),
      "phone": user?.phone,
      "attempt":this.examinfo?.attempt||'1'
    }
  //  this.showCharts = true;
   var reportSubscription =  this.testListService.testReportV2(body).subscribe((resp: any) => {
    this.testResultUtility.overallpaperSelected =  body?.ruleid.indexOf('paper') !=-1
     this.testReport = this.testResultUtility.overallpaperSelected ?  { ...resp } : resp?.find(v=>v?.name == 'overall')?.data
     this.testResultUtility.overallpaperResult = resp;
     const examSubmittedDate = new Date(resp.examSubmittedOn);
     this.showGiftPopup = (examSubmittedDate.getFullYear() >= 2022 && examSubmittedDate.getMonth() >= 6) ? true : false;
    this.testReport.totaltimespentinhrs=Number.isInteger(this.testReport?.totaltimespentinhrs)?this.testReport?.totaltimespentinhrs: this.testReport?.totaltimespentinhrs?.slice(0,-4)
    this.testReport.spentaverageTimePerQuestion =  this.testReport?.averageTimePerQuestion;
     this.testReport.averageTimePerQuestion = this.getTimeDetails(this.testReport?.averageTimePerQuestion);
     this.testReport.overallChartData.data = [this.testReport.correctAnswer, this.testReport.incorrectAnswer, this.testReport.unAttemptedQuestions];
     this.testReport.overallChartData.count = this.testReport.attemptedQuestions + this.testReport.unAttemptedQuestions;
     this.loadChartData()
     this.showCharts = true;
    this.isTimeBoundTest = timeBoundTypes.indexOf(this.examinfo.examtype) > -1;
    resp?.testSubjects?.forEach((v)=>{
      v?.chapters?.sort((a,b)=>b?.accuracy - a?.accuracy)
  })
    if(this.isTimeBoundTest){
      if (this.viewSolutionAvailabilityInterval) {
        this.viewSolutionAvailabilityInterval.stop();
        this.viewSolutionAvailabilityInterval = null;
      }
      this.updateViewSolutionAvailabilityTimeboundTest()
    }
    this.bestSubjectChapters = this.testReport?.testSubjects?.find(v=>v?.subjectName?.toLowerCase() == resp?.bestSubject?.toLowerCase() )
    if(this.quesCount>=10){
      this.sendData();
    }
    //?sending count when ites more thsendFeedbackDataan 90
    if(this.testReport?.percentile>90){
      this.sendFeedbackData();
    }
    this.trackingData = JSON.parse(localStorage.getItem('score-tracking-data'));
    // if (this.examinfo.examtype == 'SCHOLARSHIPTEST' && this.trackingData?.feedback) {
    //   this.sendDetailsToLSQ(this.testReport);
    // }
    this.sendScholarshipLSQ()
     this.getExamsQuestions(user)
    if(this.checkILTSRevampapplicable(this.examinfo)){
     this.testListService.getReportTemplate().subscribe((response:any) => {
      let cmsData = filterCMSData()?.[0];
      let cmsMapKey :any= {
        "JEE Advanced":'jeeAdvance',
        "NEET":'neet',
        "JEE Main":'jeeMains'
      }
      let targetExam =localStorage.getItem('targetExamName')
       if (cmsData?.UAM_Grade_Name == "8th" && targetExam == 'FOUNDATIONTEST') {
         this.examRanges = response?.data?.['FoundationJEE']
       }
       else if ((cmsData?.UAM_Grade_Name == "9th" || cmsData?.UAM_Grade_Name == "10th") && (targetExam == 'NEET' || targetExam == 'JEEMAIN')) {
         let tarEx = targetExam == 'NEET' ? 'FoundationNEET' : 'FoundationJEE'
         this.examRanges = response?.data?.[tarEx]
       }
       else {
         this.examRanges = response?.data[cmsMapKey[cmsData?.CMS_Exam_Name]]
       }
       let exam_type = this.testReport?.exam_type||this.testReport?.examtype;
      //  this.examRanges =  exam_type == 1 ? response?.data?.neet:response?.data?.jeeMains;
       this.testReport.timeFormat  = this.testReport?.span?new Date(this.testReport?.span):'';
       this.testReport.newCutoff =  Math.ceil((((this.examRanges?.cutoff*this.testReport?.outOfScore)/100)||this.testReport?.cutoffScore||0 ).toFixed(2));
       this.showEqualiser = true;
       this.testResultUtilityObject.showScoreRace = true
      })
    }
   },(err)=>{
     alert('Something Went Wrong')
     this.back()
   });
  this.subscriptionsArray.push(reportSubscription)
   this.spinner.hide()
 }
 sendScholarshipLSQ(){
  let amountPercentage = Number(Math.floor((this.testReport?.totalScore / this.testReport?.outOfScore)*100));
  if((this.examinfo.examtype =='SCHOLARSHIPTEST' || this.examinfo.examtype =='SCOREAWAT' || this.examinfo.examtype =='SCOREMOCKTEST')   ){
    amountPercentage = amountPercentage < 0? 0 : amountPercentage;
    if( amountPercentage > 0 || amountPercentage == 0){
        let body = {
          "amountPercentage": amountPercentage,
          "studentName": this.userData.firstName,
          "userId": this.userData.userId,
          "ruleId": this.examinfo?._id
        }
        this.subscriptionService.createCoupon(body).subscribe((resp: any) => {
          if(resp) {
            this.giftPopupInfo = resp;
            if ((this.examinfo.examtype =='SCHOLARSHIPTEST' || this.examinfo.examtype =='SCOREAWAT'|| this.examinfo.examtype.toString() =='SCOREMOCKTEST') && this.trackingData?.fromSubmit) {
              this.sendDetailsToLSQ(this.testReport, "",this.trackingData,this.examinfo);             
            }
          }
        })
    }else{
      this.sendDetailsToLSQ(this.testReport, this.giftPopupInfo,this.trackingData,this.examinfo);
    }

  }
 }
  getExamsQuestions(user) {
    if (this.paperReady) {
      if (this.QuestionsData?.questions?.subjects?.length) {
        this.QuestionsData = {...this.testResultUtility.totalQestionDataResponse[this.testResultUtility.paperSelectedOption]}
        if(Object.keys(this.QuestionsData).length){
          return;
        }
      }
      let ruleIds = this.testListService.getUSerExamlist?.completedTests?.filter(v => v.subruleid == this.examinfo?.subruleid)
      var promises = []
      ruleIds.forEach((v) => {
        let pr = new Promise((res, rej) => {
          const postdata = {
            scheduleid: this.examinfo?.scheduleid,
            ruleid: v?.id,
            studentid: user?.phone,
            attempt: v?.attempt || '1'
          }
          this.testListService.getExamQuestion(postdata).subscribe((response: any) => {
            response.papernum = v.papernum
            response.id = v.id
            res(response)
          })
        })
        promises.push(pr)
      })
      Promise.all(promises).then((result) => {
        let qustionData = []
        result.forEach(res => {
          this.testResultUtility.totalQestionDataResponse[res.id]  = { questions: { subjects: res.questions.subjects } }
          res.questions.subjects.forEach((sub) => {
            // sub.subjectAnalytics = this.testResultUtility.overallpaperResult.find(ov=>ov?.order == res?.papernum)?.data
            let findIndex = qustionData.findIndex(qu => qu.subjectname == sub.subjectname)
            if (findIndex != -1) {
              qustionData[findIndex].papers.push({ papernum: res.papernum, ...sub })
              qustionData[findIndex].questions =  qustionData[findIndex].questions.concat(sub.questions)
            } else {
              qustionData.push({
                subjectname: sub.subjectname,
                papers: [{ papernum: res.papernum, ...sub }],
                questions:sub.questions
              })
            }
          })
        })
        this.QuestionsData = { questions: { subjects: qustionData } }
        this.testResultUtility.totalQestionDataResponse[this.testResultUtility.paperSelectedOption] ={ questions: { subjects: qustionData } }
        if(this.testListService?.selectedReportPaper && this.testListService?.selectedReportPaper!=='all'){
          this.paperChange({selectedPaper:this.testListService.selectedReportPaper})
        }
      })
    } else {
      const postdata = {
        scheduleid: this.examinfo?.scheduleid,
        ruleid: this.examinfo?._id,
        studentid: user?.phone,
        attempt: this.examinfo?.attempt || '1'
      }
      this.testListService.getExamQuestion(postdata).subscribe((response: any) => {
        this.QuestionsData = response;
      })
    }

  }
  loadChartData() {
    this.chartsDatas = {
      correctAnswer: this.testReport.correctAnswer,
      incorrectAnswer: this.testReport.incorrectAnswer,
      unAttemptedQuestions: this.testReport.unAttemptedQuestions
    }
  }
  viewSolutions(subject?: any) {
    subject = subject ? `?subject=${subject}`: ''
    this.storage.clear('defaulttopicIndex');
    this.storage.clear('questioncounter');
    if(this.scheduleIdFound) {
      this.testListService.getPreviousAndPresentMockTests().subscribe(async (overallTests: any) => {
        const scheduleTestInfos: any = [];
        overallTests.forEach(element => {
          if(element.scheduleid == this.scheduleId) {
            if(this.testResponses.some(e => e.ruleid == element._id)) {
              scheduleTestInfos.push(element);
            }
          }
        });

        let dialogRef = this.dialog.open(AccountConfirmDialogComponent, {
          height: '260px',
          width: '400px',
          data: {
            showSolutionPapers: true,
            papers: scheduleTestInfos,
            disableClose: false,
          }
        });
        dialogRef.afterClosed().subscribe((value) => {
          if (value && value._id) {
            this.examService.setPresentExamInfo(value)
            this.examService.setExamRules(value);
            this.router.navigateByUrl('/dashboard/viewsolutionspage'+subject+"?schedule="+this.scheduleId)
          }
        });
      })
    } else {

      this.examService.setPresentExamInfo(this.examinfo)
      this.examService.setExamRules(this.examinfo);
      this.router.navigateByUrl('/dashboard/viewsolutionspage'+subject)
    }
  }
  examEndtime(test: any) {
    let string =test.span;
    let examstart = moment(string, "YYYY-MM-DD hh:mm A").format("YYYY-MM-DD HH:mm");
     let examendDateTime = moment(examstart,'YYYY-MM-DD HH:mm').add(parseInt(test.duration), 'minutes').format('YYYY-MM-DD HH:mm:ss');
    return examendDateTime;
  }

  ngOnDestroy() {
    this._eventHandlingService.setShowNavObs(true)
    $('body').removeClass('view-test-reports');
    if (this.viewSolutionAvailabilityInterval) {
      this.viewSolutionAvailabilityInterval.stop();
      this.viewSolutionAvailabilityInterval = null;
    }
    this.subscriptionsArray.forEach((element)=>{
      if(element?.unsubscribe){
        element.unsubscribe()
      }
    })

    if (this.rankInterval) {
      this.rankInterval.stop();
      this.rankInterval = null;
    }
  }

  viewSolutionsComingSoon() {
    let dialogRef = this.dialog.open(TestComingSoonDialogComponent, {
      height: '280px',
      width: '500px',
      data: {
        message1: 'Coming Soon!',
        message2:'The test is yet to get over. The solutions and question wise analysis will only be visible after '+moment(this.examEndtime(this.examinfo), "YYYY-MM-DD HH:mm:ss").format("hh:mm a")+' today.'
      }
    });
  }
  back(): void {
    this.router.navigate([`/dashboard/testlist/${this.examinfo?.examtype == 'SCOREAWAT' ? 'score':''}`],{queryParams:{
      examname:localStorage.getItem('targetExamName'),
      examtype:this.examinfo?.examtype
    }})
  }

  onSubjectTabChange = (tab?: MatTabChangeEvent) => {
    this.showSectionWiseReport = false;
    this.selectesSectionInd = null;
  }

  selectedSection(subject, index) {
    if (subject == 'all-section') {
      this.showSectionWiseReport = false;
      this.selectesSectionInd = null;
    } else {
      this.showSectionWiseReport = true;
      this.selectesSectionInd = index;
      this.selectedSectionToShow = 'SECTION '+(index+1);
      let sectionData = this.testReport?.testSubjects?.filter((ele) => ele?.subjectName === subject);
      let specificKey = Object.keys(sectionData[0]?.sections[index])[0];
      this.sectionData = sectionData[0]?.sections[index][specificKey];
    }
  }

  async updateViewSolutionAvailabilityTimeboundTest() {
  // await    this.testListService.getServerTime();
  localStorage.setItem('serverTime',this.getMomentUTCtime()); 
      this.checkForbuttonDisablity();
      this.viewSolutionAvailabilityInterval  = new TaskTimer(30000);
      this.viewSolutionAvailabilityInterval.on('tick', () =>{
          this.checkForbuttonDisablity()
        });
      this.viewSolutionAvailabilityInterval .start();
    //   this.viewSolutionAvailabilityInterval = new TaskTimer(30000);
    //   this.viewSolutionAvailabilityInterval.add(task => {
    //   // let examendDateTime = this.examEndtime(this.examinfo);
    //   // let serverTime = localStorage.getItem('serverTime');
    //   // let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");
    //   // if (moment(current_time).isAfter(examendDateTime)) {
    //   //   this.viewSolutionAvailableTimebound = true;
    //   //   if (this.viewSolutionAvailabilityInterval) {
    //   //     workerTimers.clearInterval(this.viewSolutionAvailabilityInterval);
    //   //     this.viewSolutionAvailabilityInterval = null;
    //   //   }
    //   // }
    //   this.checkForbuttonDisablity()
    // }).start();
  }
  
  redirectToTimeBoundTest(){
    let examendDateTime = this.examEndtime(this.examinfo);     
    let current_time = moment.utc()
    var exam_endtime_5min = moment(examendDateTime,"YYYY-MM-DD HH:mm:ss").add(5,'minute')
    if (moment(current_time).isBefore(exam_endtime_5min) && this.checkILTSRevampapplicable(this.examinfo) && this.isTimeBoundTest  &&!(this.examinfo.examtype =='SCOREAWAT' || this.examinfo.examtype == 'SCOREMOCKTEST')) {
      if (this.viewSolutionAvailabilityInterval) {
        this.viewSolutionAvailabilityInterval.stop();
        this.viewSolutionAvailabilityInterval = null;
      }
      this.router.navigate(['dashboard/reportQueue']);
      return false;
    }   
  }

  checkForbuttonDisablity(){
    let examendDateTime = this.examEndtime(this.examinfo);
    let serverTime = localStorage.getItem('serverTime');
    let current_time = moment.utc()//moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");
    var exam_endtime_5min = moment(examendDateTime,"YYYY-MM-DD HH:mm:ss").add(5,'minute')
    if (current_time.isAfter(exam_endtime_5min)) {
      this.viewSolutionAvailableTimebound = true;
      if (this.viewSolutionAvailabilityInterval) {
        this.viewSolutionAvailabilityInterval.stop();
        this.viewSolutionAvailabilityInterval = null;
      }
    }
    // else if(this.checkILTSRevampapplicable(this.examinfo) && this.isTimeBoundTest && !this.viewSolutionAvailableTimebound &&!(this.examinfo.examtype =='SCOREAWAT' || this.examinfo.examtype == 'SCOREMOCKTEST')){
    //   if (this.viewSolutionAvailabilityInterval) {
    //     this.viewSolutionAvailabilityInterval.stop();
    //     this.viewSolutionAvailabilityInterval = null;
    //   }
    //   if(this.autoRedirectionfix){
    //     if(localStorage.getItem('currentPage') != 'testinstructions'){ //?stoping unwanted redirection
    //       this.router.navigate(['dashboard/reportQueue']);
    //     }
    //   }else{
    //     this.router.navigate(['dashboard/reportQueue'])
    //   }

    // }
    if(this.examinfo.examtype =='SCOREAWAT'){
      this.viewSolutionAvailableTimebound = true;
    }
  }





  checkIfGiftCoupenAvailable(){
    return ((this.showGiftPopup)
    && (this.examinfo.examtype =='SCHOLARSHIPTEST' || this.examinfo.examtype == 'MOCKTEST' ||
    this.examinfo.examtype == 'TIMEBOUND' || this.examinfo.examtype =='SCOREMOCKTEST' ||
    this.examinfo.examtype == 'NEW NEET MOCK TEST' || this.examinfo.examtype == 'NEW NEET TIMEBOUND' ||
    this.examinfo.examtype == 'PREVIOUSYEAR'|| this.examinfo.examtype =='SCOREAWAT' ))
  }

  scGiftCoupn() {
    // ||!( Number(Math.floor((this.testReport?.totalScore / this.testReport?.outOfScore)*100))>0)
    if (this.dialogRefGifts != undefined) return;
    const config: MatDialogConfig = {
      panelClass: ['sc-gftcpn-dialog', 'UNFAPP-mweb-btmstiky-modal'],
      width:'250',
      data: { giftPopupInfo: this.giftPopupInfo, studentName: this.userData.firstName, percentile: Number((this.testReport?.totalScore / this.testReport?.outOfScore)*100).toFixed(2)}
    };
    // if(  this.examinfo.examtype !=='SCOREAWAT' ){
    //   this.dialogRefGifts = this.dialog.open(FreeScoreGiftDialogComponent, config);
    // }

    if(this.examinfo.examtype !=='SCOREMOCKTEST' ){
      this.dialogRefGifts = this.dialog.open(FreeScoreGiftDialogComponent, config);
     }

    // this.dialogRefGifts = (this.examinfo.examtype =='SCHOLARSHIPTEST' || this.examinfo.examtype =='SCOREAWAT' ) ?
    // this.dialog.open(ScoreGiftDialogComponent, config) :
    // this.dialog.open(FreeScoreGiftDialogComponent, config);
    this.dialogRefGifts.afterClosed().pipe(
      finalize(() => {this.dialogRefGifts = undefined;
      this.spinner.hide()
    })
    );
  }
  downloadScoreCertificate(){
     let cFactory = this.resolver.resolveComponentFactory(scorecertificatecomponent);
    let componentRef = this.viewContainerRef.createComponent(cFactory);
    componentRef.instance.dateofexam = moment(this.examinfo?.examStartedOn).utc().format('DD-MMMM-YYYY')
    // let param = {
    //   firstName: this.userData?.firstName,
    //   lastName: this.userData?.lastName,
    //   date: moment(this.examinfo?.examsubmittedon).utc().format('DD-MMMM-YYYY')
    // }

    // this.examService.downloadScoreTestCertificate(param).subscribe((resp:any)=>{

    // })
  }

  fetchAvgAndCutOffScore(examinfo: any, courseType: any) {
    this.spinner.show();
    let data={​​​​​​​​
      "scheduleid": examinfo?.scheduleid,
      "coursetype": examinfo?.courseType || courseType,
      "year":new Date(examinfo?.examsubmittedon)?.getFullYear()
    }​​​​​​​​
    this.examService.getAvgAndCutOffScore(data, this.token).subscribe((data:any) => {
      this.averageScore = data?.averageScore;
      this.cutOffScore = parseFloat(data?.cutoffScore);
      this.getReportUSingV2TestTeport();
      this.spinner.hide();
    }, err => {
      this.getReportUSingV2TestTeport();//incase of API Failure
      this.spinner.hide();
    })
    this.spinner.hide()
  }
  paperChange(event){
    this.testResultUtility.paperSelectedOption =  event?.selectedPaper;
    this.getReportUSingV2TestTeport()
  }
  setPaperRuleID(){
    this.paperReady = this.checkJEEAdvancedMultiplePaper(this.examinfo,this.testListService.getUSerExamlist);  
    if(this.paperReady){
      this.testResultUtility.paperSelectedOption = this.examinfo?.subruleid;
     } 
    this.fetchAvgAndCutOffScore(this.examinfo, this.examinfo?.courseType);
  }
}
export  function sendDetailsToLSQ(testReport, couponData,trackingData,examinfo) {
  // let body1 = {
  //   ruleid: this.trackingData?.ruleId,
  // };
  // this.spinner.show();
  // this.subscriptionService.getTimeSlotData(body1).subscribe(
  //   (res: any) => {
      let userData = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
      // let examDt = res[0]?.span;
      let payload = {
        data: {
          score_exam_type: examinfo.examtype,
          score_target_exam: localStorage.getItem('targetExamName'),
          score_exam_date: moment(examinfo?.createdDate)?.utc()?.format("DD-MMM-YYYY") ,
          score_time_slot:  null,
          score_mode_of_exam: 'online',
          score_grade: 'Grade '+ userData?.grade?.name?.replace('th', ''),
          score_score: `${testReport?.totalScore}/${testReport?.outOfScore}`,
          score_percentile: testReport?.percentile,
          score_feedback_1: trackingData?.feedback?.experience ? (trackingData?.feedback?.experience == 'BAD' ? 1 : trackingData?.feedback?.experience == 'FAIR' ? 2 : 3) : null,
          score_feedback_2: trackingData?.feedback?.difficultylevel ? (trackingData?.feedback?.difficultylevel[0] == 'EASY' ? 1 : trackingData?.feedback?.difficultylevel[0] == 'MEDIUM' ? 2 : 3) : null,
          score_coupon_code: couponData?.code ? couponData?.code : '',
          score_interest_in_online_or_offline: trackingData?.score_interest_in_online_or_offline_courses || null,
          score_exam_started_date: trackingData?.score_exam_started_date,
          score_exam_submitted_date: trackingData?.score_exam_submitted_date,
          score_time_of_exam_attempted: trackingData?.score_time_of_exam_attempted,
          score_time_of_exam_submitted: trackingData?.score_time_of_exam_submitted,
          score_scholarship_percentage: examinfo.examtype !='SCOREMOCKTEST' ? couponData?.amountPercentage||0 :'', //couponData?.amountPercentage||0
          score_test_report: `${window.location.origin}/score/test-report/registration?phone=${+userData?.phone}&attempt=${examinfo?.attempt}&ruleid=${examinfo?._id}`,
          phone_number:userData?.phone,
          attempt : examinfo.attempt ? examinfo.attempt : '1'

        },
        "landingPage" : "LSQ_CUSTOM_EVENTS"
      };
      let  firebasePayload = {
        "ActivityDateTime": moment().utc().format("YYYY-MM-DD HH:mm:ss"),
        "ActivityEvent": 269,
        "Fields":{},
        "FirstName": this.userData?.firstName,
        "LastName": this.userData?.lastName,
        "environment": environment?.branch,
        "phone": this.userData?.phone,
        "productId": 1,
        "type": "Activity"
      }
      this.spinner.show();
      isUserAdmin(this.userService).then((bool) => {
        if(!bool) {
          localStorage.removeItem('score-tracking-data');
          // this.userService.callTrackingAPI2(userData.userId, payload,'Act_Score').subscribe((data) => {
          //   localStorage.removeItem('score-tracking-data');
          //   this.spinner.hide();
          // }, err => {
          //   this.spinner.hide();
          // });

          this.firebaseService.getSqsValue().then((firebaseRSP) => {
            firebasePayload.Fields = {
              mx_Custom_1: examinfo.examtype,
              mx_Custom_2: localStorage.getItem('targetExamName'),
              mx_Custom_3: moment(examinfo?.createdDate)?.utc()?.format("DD-MMM-YYYY") ,
              mx_Custom_4:  null,
              mx_Custom_5: 'online',
              mx_Custom_6: 'Grade '+ userData?.grade?.name?.replace('th', ''),
              // score_score: `${testReport?.totalScore}/${testReport?.outOfScore}`,
              // score_percentile: testReport?.percentile,
              // score_feedback_1: trackingData?.feedback?.experience ? (trackingData?.feedback?.experience == 'BAD' ? 1 : trackingData?.feedback?.experience == 'FAIR' ? 2 : 3) : null,
              // score_feedback_2: trackingData?.feedback?.difficultylevel ? (trackingData?.feedback?.difficultylevel[0] == 'EASY' ? 1 : trackingData?.feedback?.difficultylevel[0] == 'MEDIUM' ? 2 : 3) : null,
              // score_coupon_code: couponData?.code ? couponData?.code : '',
              // score_interest_in_online_or_offline: trackingData?.score_interest_in_online_or_offline_courses || null,
              // score_exam_started_date: trackingData?.score_exam_started_date,
              // score_exam_submitted_date: trackingData?.score_exam_submitted_date,
              // score_time_of_exam_attempted: trackingData?.score_time_of_exam_attempted,
              // score_time_of_exam_submitted: trackingData?.score_time_of_exam_submitted,
              // score_scholarship_percentage: examinfo.examtype !='SCOREMOCKTEST' ? couponData?.amountPercentage||0 :'', //couponData?.amountPercentage||0
              // score_test_report: `${window.location.origin}/score/test-report/registration?phone=${+userData?.phone}&attempt=${examinfo?.attempt}&ruleid=${examinfo?._id}`,
              // phone_number:userData?.phone,
              // attempt : examinfo.attempt ? examinfo.attempt : '1'
            }
            this.userService.sendSQSMsg(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,firebasePayload);
            this.spinner.hide();
          }).catch((e) => {
            console.log(e);
            this.spinner.hide();
          });
        }
      }).catch(err=>{
        this.spinner.hide()
      })
      this.spinner.hide()
    // }, err => {
    //   this.spinner.hide();
    // });
}
export function checkILTSRevampapplicable(test) {
  let cmsDetails = filterCMSData();
  let allowReport = false;
  if (['066697cf-709c-4c67-a0bb-e43feb0043d9', '51592ef8-8334-479f-8a91-7cfe809b7c04'].some(v => v == test?.test_type)) {
    allowReport = ["NEET", "JEE Main", "JEE Advanced","Foundation Test"].some(v => v == cmsDetails?.[0].UAM_Exam_Name) && ([8, 9, 10,11, 12, 13].some(v => v == cmsDetails?.[0]?.CMS_Grade_Name))
  } else if (['5f9624f0-098c-41c6-999b-d847c7e4e3a3', '5d6fcff0-1000-45bb-b62a-d3d2b2bd3189',"066697cf-709c-4c67-a0bb-e43feb0043d9"].some(v => v == test?.test_type)) {
    allowReport = ["NEET", "JEE Main", "Foundation Test"].some(v => v == cmsDetails?.[0].UAM_Exam_Name) && ([8, 9, 10, 11, 12, 13].some(v => v == cmsDetails?.[0]?.CMS_Grade_Name))
  }
  return allowReport
}
export function examEndtime(test: any) {
  let string =test.span;
  let examstart = moment(string, "YYYY-MM-DD hh:mm A").format("YYYY-MM-DD HH:mm");
   let examendDateTime = moment(examstart,'YYYY-MM-DD HH:mm').add(parseInt(test.duration), 'minutes').format('YYYY-MM-DD HH:mm:ss');
  return examendDateTime;
}
export function checkJEEAdvancedMultiplePaper(examInfo,getUSerExamlist){
  let cmsDetails = filterCMSData();
  return ["JEE Advanced"].some(v=>v==cmsDetails?.[0]?.UAM_Exam_Name) && getUSerExamlist?.completedTests?.filter(v=>v.subruleid == examInfo?.subruleid)?.length >1  
}
